import React from 'react'
import PropTypes from 'prop-types'
import {
  ExperienceLaunchButton,
  ExperienceLaunchWrapper,
  LinkExpiryCaption,
} from './component.styles'
import {
  LAUNCH_EXPERIENCE_BUTTON_TEXT,
  LAUNCH_EXPERIENCE_LOADING_TEXT,
  LINK_EXPIRES_PREFIX,
} from './constants'

const formatExpiryDate = expiresAt => {
  const date = new Date(expiresAt)
  if (Number.isNaN(date.getTime())) {
    return null
  }
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  })
}

const ExperiencePlayerLaunchButton = ({
  dataTestId,
  expiresAt,
  forceFixedWidth,
  isCreating,
  isHighSchool,
  label,
  onClick,
}) => {
  const formattedExpiry = expiresAt ? formatExpiryDate(expiresAt) : null

  return (
    <ExperienceLaunchWrapper>
      <ExperienceLaunchButton
        $forceFixedWidth={forceFixedWidth}
        $isHighSchoolButton={isHighSchool}
        data-testid={dataTestId}
        disabled={isCreating}
        onClick={onClick}
      >
        {isCreating
          ? LAUNCH_EXPERIENCE_LOADING_TEXT
          : label || LAUNCH_EXPERIENCE_BUTTON_TEXT}
      </ExperienceLaunchButton>
      {!!formattedExpiry && (
        <LinkExpiryCaption data-testid="launch-experience-expiry">
          {`${LINK_EXPIRES_PREFIX} ${formattedExpiry}`}
        </LinkExpiryCaption>
      )}
    </ExperienceLaunchWrapper>
  )
}

ExperiencePlayerLaunchButton.propTypes = {
  dataTestId: PropTypes.string,
  expiresAt: PropTypes.string,
  forceFixedWidth: PropTypes.bool,
  isCreating: PropTypes.bool,
  isHighSchool: PropTypes.bool,
  label: PropTypes.string,
  onClick: PropTypes.func.isRequired,
}

export default ExperiencePlayerLaunchButton
